// theme-scripts.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const initGSAP = () => {
    gsap.registerPlugin(ScrollTrigger);

    initGSAPAnimations();
    
    function initGSAPAnimations() {
        // optional: if layout shifts after load
        window.addEventListener("load", () => ScrollTrigger.refresh());

        // Reveal-ups
        gsap.utils.toArray(".reveal-up").forEach((el) => {
            gsap.from(el, {
            y: 24,
            autoAlpha: 0,
            duration: 0.6,
            ease: "power2.out",
            scrollTrigger: {
                trigger: el,
                start: "top 60%",
                once: true,
            },
            });
        });

        // Straggered Columns
        gsap.utils.toArray("[data-stagger]").forEach((wrap) => {
            const sel = ".columns__item";
            const items = Array.from(wrap.querySelectorAll(sel));
            if (!items.length) return;

            gsap.from(items, {
            y: 16,
            autoAlpha: 0,
            duration: 0.5,
            ease: "power2.out",
            stagger: 0.12,
            scrollTrigger: {
                trigger: wrap,
                start: "top 85%",
                once: true,
            },
            });
        });

        // Straggered Images
        gsap.utils.toArray("[data-stagger]").forEach((wrap) => {
            const sel = ".image__content";
            const items = Array.from(wrap.querySelectorAll(sel));
            if (!items.length) return;

            gsap.from(items, {
            y: 16,
            autoAlpha: 0,
            duration: 1,
            ease: "power2.out",
            stagger: 0.08,
            scrollTrigger: {
                trigger: wrap,
                start: "top 85%",
                once: true,
            },
            });
        });

        // Media Animations
        const mediaReady = (el) => {
            if (!el) return Promise.resolve();
            const tag = el.tagName;
            if (tag === "IMG")  return el.decode ? el.decode().catch(()=>{}) : Promise.resolve();
            if (tag === "VIDEO") return el.readyState >= 2 ? Promise.resolve()
                : new Promise(r => el.addEventListener("loadeddata", r, { once:true }));
            if (tag === "IFRAME") return new Promise(r => el.addEventListener("load", r, { once:true }));
            return Promise.resolve();
        };

        gsap.utils.toArray(".module.media").forEach((wrap) => {
            const moduleEl = wrap.closest(".img-reveal") || wrap;
            const media = wrap.querySelector("img, video, picture img, iframe");

            if (!media) return;

            const tween = gsap.fromTo(
                media,
                { clipPath: "inset(0 0 100% 0)", yPercent: 40 },
                { clipPath: "inset(0 0 0% 0)", yPercent: 0, duration: 2, ease: "power3.out",
                paused: true, immediateRender: false }
            );

            ScrollTrigger.create({
                trigger: moduleEl,
                start: "top 85%",
                once: true,
                onEnter: async () => {
                    await mediaReady(media);
                    tween.play();
                },
            });
        });

        // Hero Lines
        const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        const heroImageSelectors = ".hero-level-1__image, .hero-carousel__gallery";
        gsap.utils.toArray(heroImageSelectors).forEach((el) => {
            if (prefersReduced) {
                gsap.set(el, { "--line1": 1, "--line2": 1 });
                return;
            }

            const tl = gsap.timeline({ paused: true })
                .to(el, { duration: 0.5, ease: "power2.out", "--line1": 1 })
                .to(el, { duration: 0.5, ease: "power2.out", "--line2": 1 }, "-=0.25");

            ScrollTrigger.create({
                trigger: el,
                start: "bottom bottom",
                onEnter: () => tl.play(),
                // onEnterBack: () => tl.reverse(),
            });
        });

        gsap.utils.toArray(".hero-level-1__video").forEach((el) => {
            if (prefersReduced) {
                gsap.set(el, { "--line1": 1, "--line2": 1 });
                return;
            }

            // timeline that grows both lines (slight overlap)
            const tl = gsap.timeline({ paused: true })
                .to(el, { duration: 0.5, ease: "power2.out", "--line1": 1 })
                .to(el, { duration: 0.5, ease: "power2.out", "--line2": 1 }, "-=0.25");

            ScrollTrigger.create({
                trigger: el,
                start: "bottom bottom",
                onEnter: () => tl.play(),
                // onEnterBack: () => tl.reverse(),
            });
        });
    }

    // Buttons Animations
    const btns = document.querySelectorAll(".btn");
    if (btns.length) {
        btns.forEach((btn) => {
            const lift   = () => gsap.to(btn, { y: -3, duration: 0.18, ease: "power2.out", overwrite: "auto" });
            const settle = () => gsap.to(btn, { y:  0, duration: 0.20, ease: "power2.out", overwrite: "auto" });

            btn.addEventListener("pointerenter", (e) => {
                if (e.pointerType && e.pointerType !== "mouse") return; // ignore touch/pen
                lift();
            });

            btn.addEventListener("pointerleave", (e) => {
            if (e.pointerType && e.pointerType !== "mouse") return;
                settle();
            });

            // keyboard-friendly
            btn.addEventListener("blur",   () => settle());
        });
    }
};

export default initGSAP;